import { render, staticRenderFns } from "./Advisers.vue?vue&type=template&id=54c5118f&scoped=true"
import script from "./Advisers.vue?vue&type=script&lang=js"
export * from "./Advisers.vue?vue&type=script&lang=js"
import style0 from "./Advisers.vue?vue&type=style&index=0&id=54c5118f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c5118f",
  null
  
)

export default component.exports